import '../styles/Map.css';

export default function Map() {
  return (
    <section className="map-section">
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps?q=Serrano%2093%20Madrid&output=embed"
          loading="lazy"
          title="Mapa Serrano 93"
          allowFullScreen=""
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
}